export const INSTRUCTIONS_URL =
  "https://github.com/washingtonpost/crosswalker#documentation";

export const SELECT_INSTRUCTIONS_URL =
  "https://github.com/washingtonpost/crosswalker#configuring-columns";

export const SPREADSHEET_INSTRUCTIONS_URL =
  "https://github.com/washingtonpost/crosswalker#interactive-spreadsheet";

export const SOURCE_URL = "https://github.com/washingtonpost/crosswalker";

export const WASHINGTON_POST_URL = "https://www.washingtonpost.com/";
